import { render, staticRenderFns } from "./MovementsReport.vue?vue&type=template&id=659a3b93&scoped=true"
import script from "./MovementsReport.vue?vue&type=script&lang=js"
export * from "./MovementsReport.vue?vue&type=script&lang=js"
import style0 from "./MovementsReport.vue?vue&type=style&index=0&id=659a3b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659a3b93",
  null
  
)

export default component.exports